import { TopStatsSection } from '@wehunt/ui'
import { useChronicleTopStats } from './useChronicleTopStats'

export interface ChronicleTopStatsProps {
  teamIds: string[]
  teamsById?: Record<string, string>
  onContinueWithTeam?: (teamId: string) => void
}

export function ChronicleTopStats({ teamIds, teamsById, onContinueWithTeam }: ChronicleTopStatsProps) {
  const stats = useChronicleTopStats(teamIds)
  const lastTeamName = stats.lastTeamId && teamsById ? teamsById[stats.lastTeamId] : undefined

  return (
    <TopStatsSection
      teamCount={stats.teamCount}
      totalHectares={stats.totalHectares}
      groundCount={stats.groundCount}
      lastTeamId={stats.lastTeamId}
      lastTeamName={lastTeamName}
      onContinueWithTeam={onContinueWithTeam}
    />
  )
}
